import React, { Component } from "react";

export class AddForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPost: false,
            loading: false,
            settingsRequired: {
                ProcessId: false,
                Comment: false,
                Payment: false,
                WayToPay: false,
                RegisterDate: false
            },

            model: {
                ProcessId: 0,
                Comment: '',
                Payment: 0,
                WayToPay: '',
                RegisterDate: ''
            },
        }
    }

    componentDidMount() {
        this.props.reLoad.bind(this);
    }

    async getProcess(event) {
        this.state.processFind = [];
        if (event.currentTarget.value && event.currentTarget.value.length > 2) {
            this.setState({ loading: true, currentInput: event.currentTarget });
            const request = {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                }
            }
            event.currentTarget.focus();
            let response = await fetch(`Process/GetProcessByLike?param=${event.currentTarget.value}`, request);
            if (response.redirected) {
                window.location.href = response.url;
            }
            this.setState({ loading: false });
            if (response.status == 200) {
                let data = await response.json();
                this.setState({ processFind: data });
                this.state.currentInput.focus();
            }
            else {
                alert('Error obteniendo los procesos');
            }

        }
    }

    handleSelectProcess(event) {
        document.querySelector('#searchProcess').value = '';
        this.state.model.ProcessId = parseInt(event.currentTarget.dataset.id);
        this.state.settingsRequired.ProcessId = true;
        this.setState({ processNameSelected: event.currentTarget.value, processFind: [] });
    }

    removeSelectProcess(event) {
        this.state.model.ProcessId = 0;
        this.state.settingsRequired.ProcessId = false;
        this.setState({ processNameSelected: '', processFind: [] });
    }

    setModel(event) {

        this.state.model['ClientId'] = this.props.ClientId;

        if (event.currentTarget.value) {
            this.state.model[event.currentTarget.dataset.name] = event.currentTarget.dataset.iscurrency ? parseInt(event.currentTarget.value) : event.currentTarget.value;
            this.state.settingsRequired[event.currentTarget.dataset.name] = true;
        } else {
            this.state.model[event.currentTarget.dataset.name] = '';
            this.state.settingsRequired[event.currentTarget.dataset.name] = false;
        }

        if (event.currentTarget.dataset.iscurrency) {
            this.formatCurrency(event);
        }
    }

    formatCurrency(val) {

        var formatted = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 2
        }).format(val);
        return formatted;
    }

    formIsValid() {
        return Object.values(this.state.settingsRequired).find((a) => { return !a }) == undefined ? true : false;
    }

    async save() {
        this.setState({ isPost: true });
        if (this.formIsValid()) {
            this.setState({ loading: true });
            const request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(this.state.model)
            }
            let response = await fetch(`Financial/Post`, request);
            if (response.redirected) {
                window.location.href = response.url;
            }
            this.setState({ loading: false });

            if (response.status == 401) {
                alert('No está autorizado para esta operación.');
            }

            if (response.status == 200) {
                alert('Guardado con éxito');
                this.props.reLoad();
                let data = await response.json();
            }
            else {
                alert('Error procesando los datos.');
            }
        }
    }

    render() {
        return (<div>
            <div className="form-group">
                <label>Proceso</label>

                {!this.state.processNameSelected ?
                    <input type="text" id="searchProcess" className="form-control" disabled={this.state.loading} onChange={(event) => { this.getProcess(event) }} /> :
                    null
                }

                {this.state.processNameSelected ?
                    <div className="form-control">
                        <span>{this.state.processNameSelected}</span>
                        <span className="remove" onClick={() => { this.removeSelectProcess() }} title="Eliminar filtro">x</span>
                    </div> :
                    null
                }

                {this.state.loading ? <span>Por favor espere...</span> : null}
                {!this.state.settingsRequired.ProcessId && this.state.isPost ? <span className="error required">Campo requerido</span> : null}

                {this.state.processFind ? this.state.processFind.map((e) => <ul>
                    <input type="button" value={e.description} data-id={e.id} onClick={(event) => { this.handleSelectProcess(event) }} />
                </ul>) : null}

            </div>
            <div className="form-group">
                <label>Observaciones</label>
                <textarea className="form-control" data-name="Comment" onBlur={(event) => { this.setModel(event) }} />
                {!this.state.settingsRequired.Comment && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
            </div>
            <div className="form-group">
                <label>Valor en pesos (COP)</label>
                <input type="number" className="form-control" data-isCurrency="true" data-name="Payment" onBlur={(event) => {
                    this.setModel(event)
                }} />
                {!this.state.settingsRequired.Payment && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
            </div>
            <div className="form-group">
                <ul>
                    <li>
                        <label for="Cash">
                            <input id="Cash" type="radio" name="way-to-pay" value="Efectivo" data-name="WayToPay" onClick={(event) => { this.setModel(event); this.setState({ showDetalPayment: false }) }} /> Efectivo
                                </label>
                    </li>
                    <li>
                        <label for="Transfer">
                            <input id="Transfer" type="radio" name="way-to-pay" value="Transferencia" data-name="WayToPay" onClick={(event) => { this.setModel(event); this.setState({ showDetalPayment: true }) }} /> Transferencia
                                </label>
                    </li>
                    <li>
                        <label for="Payu">
                            <input id="Payu" type="radio" name="way-to-pay" value="Botón de Payu" data-name="WayToPay" onClick={(event) => { this.setModel(event); this.setState({ showDetalPayment: true }) }} /> Botón de Payu
                                </label>
                    </li>
                </ul>
                {!this.state.settingsRequired.WayToPay && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
            </div>
            {this.state.showDetalPayment ?
                <div>
                    <div className="form-group">
                        <label>N&uacute;mero de referencia</label>
                        <input type="text" className="form-control" data-name="ReferenceCode" onBlur={(event) => { this.setModel(event) }} />
                        <span className="error info required">Este campo no es obligatorio, pero si tiene la referencia de pago, agréguela</span>
                    </div>
                </div>
                : null}
            <div className="form-group">
                <label>Fecha</label>
                <input type="date" className="form-control" data-name="RegisterDate" onBlur={(event) => { this.setModel(event) }} />
                {!this.state.settingsRequired.RegisterDate && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
            </div>
            <div className="form-group">
                <input type="button" className="btn btn-primary" value={this.state.loading ? 'Procesando...' : 'Guardar'} disabled={this.state.loading} onClick={() => { this.save() }} />
            </div>
        </div>)
    }
}